import React from "react";
import Classification from "./Classification";
import ClassificationTypeService from "../../../../../../services/ClassificationTypeService";
import ClassificationService from "../../../../../../services/ClassificationService";
import { constants } from "../../../../../../utils/Constants";
import CommonUtil from "../../../../../../utils/CommonUtil";

import { paths } from "../../../../../paths";
import { withRouter } from "react-router-dom";
import { activeFilter } from "../../../../../../services/FilteringUtils";
import PathUtil from "../../../../../../utils/PathUtil";
import SearchableTreeComponent from "../../../../page/SearchableTreeComponent/SearchableTreeComponent";
import { withKeycloak } from "@react-keycloak/web";

class ClassificationContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.classificationTypeService = new ClassificationTypeService(
      this.keycloak
    );
    this.classificationService = new ClassificationService(this.keycloak);

    this.state = this.initialState();
  }

  initialState() {
    return {
      ...super.initialState(),
      show: false,
      isNew: false,
      statuses: [],
      types: []
    };
  }

  initialPageSize() {
    return 12;
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onRootDataLoad = data => {
    const pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    const content = data._embedded.content.map(item => {
      return {
        ...item,
        key: constants.TYPE_PREFIX + item.id,
        selectable: false,
        disabled: true
      };
    });
    this.setState({
      loadedKeys: [],
      content: content,
      links: data._links,
      pageInfo: pageInfo
    });
  };

  loadRoots = pageInfo => {
    pageInfo = {
      ...pageInfo,
      filters: {
        ...activeFilter,
        classificationActive: pageInfo.filters
          ? pageInfo.filters.active
          : this.state.pageInfo.active
      }
    };

    this.prepareCall(
      this.classificationTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onRootDataLoad,
        this.messageHandler.handleError
      )
    );
    return this.performCalls();
  };

  updateParent = (child, parent) => {
    let classification;
    if (!parent.disabled) {
      classification = {
        _links: child._links,
        parent: {
          id: parent.id
        }
      };
    } else {
      classification = {
        _links: child._links,
        classificationType: {
          id: parent.id
        }
      };
    }

    this.prepareCall(
      this.classificationService.putEntity(
        classification,
        this.onEmptyLoad,
        this.messageHandler.handleError
      )
    );
    return this.performCalls();
  };

  onTypeDataLoad = data => {
    const treeNodeData = this.state.content.find(
      item =>
        "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_TYPE_ID,
          data._links.self.href
        )
    );

    this.state.loadedKeys.push(treeNodeData.key);

    if (data._embedded !== undefined) {
      const children = data._embedded.content.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: true,
          disabled: false
        };
      });
      treeNodeData.children = children;
    } else {
      treeNodeData.children = undefined;
      treeNodeData.leaf = true;
    }
    this.setState({
      loadedKeys: this.state.loadedKeys,
      content: [...this.state.content]
    });
  };

  loadDataByType = type => {
    this.prepareCall(
      this.classificationService.getClassificationsByType(
        type,
        this.onTypeDataLoad,
        this.messageHandler.handleError,
        this.getPageInfoActiveFilters()
      )
    );
    return this.performCalls();
  };

  loadDataByParent = parent => {
    this.prepareCall(
      this.classificationService.getClassificationsChildren(
        parent,
        this.onDataLoad,
        this.messageHandler.handleError,
        this.getPageInfoActiveFilters()
      )
    );
    return this.performCalls();
  };

  getPageInfoActiveFilters() {
    return {
      filters: {
        active: this.state.pageInfo.filters.active
      }
    };
  }

  loadData = expanded => {
    if (expanded.disabled) {
      return this.loadDataByType(expanded);
    } else {
      return this.loadDataByParent(expanded);
    }
  };

  onClick = key => {
    let dataRef;
    if (this.state.searchValue && this.state.searchValue !== "") {
      dataRef = this.state.content.find(item => item.key === key);
    } else {
      dataRef = this.findInTreeByKey(this.state.content, key);
    }
    if (!dataRef) return;

    const classifiactionDetailPath = PathUtil.adminItemsPath(
      { path: paths.CLASSIFICATIONS },
      { path: paths.DETAIL, id: dataRef.id }
    );
    this.changePath(classifiactionDetailPath, dataRef.name);
  };

  handleShow = () => {
    const classifiactionDetailPath = PathUtil.adminItemsPath(
      { path: paths.CLASSIFICATIONS },
      { path: paths.DETAIL }
    );
    this.changePath(classifiactionDetailPath);
  };

  checkNodeCallback = (item, data) => {
    return (
      !item.key.startsWith(constants.TYPE_PREFIX) &&
      "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_PARENT_ID,
          data._links.self.href
        )
    );
  };

  loadEntitiesWithFilter = pageInfo => {
    this.loadClassificationsWithFilter(pageInfo);
  };

  loadClassificationsWithFilter = pageInfo => {
    this.prepareCall(
      this.classificationService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onLoadWithFilter,
        this.messageHandler.handleError
      )
    );
    return this.performCalls();
  };

  render() {
    return (
      <Classification
        {...this.renderProps()}
        onClick={this.onClick}
        activeValue={this.state.pageInfo.filters}
        handleShow={this.handleShow}
      />
    );
  }
}

export default withKeycloak(withRouter(ClassificationContainer));
